import { render, staticRenderFns } from "./SCR_MBC_0115_03.vue?vue&type=template&id=9580fd30&scoped=true&"
import script from "./SCR_MBC_0115_03.vue?vue&type=script&lang=js&"
export * from "./SCR_MBC_0115_03.vue?vue&type=script&lang=js&"
import style0 from "./SCR_MBC_0115_03.vue?vue&type=style&index=0&id=9580fd30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9580fd30",
  null
  
)

export default component.exports